module.exports = __webpack_public_path__ + "toBride2-we-p-g.ca490297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-p-g.jpg
// module id = nxU3
// module chunks = 0